// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2lrPF","label":"Category_label__10pij","content":"Category_content__2KJ-V","header":"Category_header__12iff","location":"Category_location__17usv"};